import request from "./request";

const http = {
  // 差异列表
  aprList(data) {
    return request.post("/platform/pc/order/extra/list", data);
  },
  //差异订单备注记录
  noteRecord(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/extra/noteRecord",
      params: params,
    });
  },
  //差异订单添加备注
  aprAddNote(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/extra/addNote",
      data: params,
    });
  },
  //添加备注图片
  aprAddNoteImage(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/extra/addNoteImage",
      data: params,
    });
  },

  // 差异详情
  extraDetatil(data) {
    return request.post("/platform/pc/order/extra/detail", data);
  },

  //Q-详情(差异流程)
  flowDetail(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/extra/detail/middle",
      data: params,
    });
  },

  //初审
  auditFirst(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/extra/auditFirst",
      data: params,
    });
  },
  //复核
  auditRe(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/extra/auditRe",
      data: params,
    });
  },
  // 导表
  extraExcel(data) {
    return request.post("/platform/pc/order/extra/excel", data, {
      responseType: "blob",
    });
  },
};

export default http;
